module.exports = {
  tokenInvalid: '当前登录已过期，请重新登录。',
  requestError: '请求错误。',
  timeOut: '网关超时。',
  code404: '请求失败，状态代码为404',
  loginNameExists: '登录名或邮箱已存在！',
  codeInvalid: '授权码无效或已过期。',
  accountExpired: '用户帐户已过期',
  systemError: '系统未知异常'
}
